package com.artvending.warden.screens.home

import androidx.compose.runtime.Composable
import com.artvending.warden.Alignment
import com.artvending.warden.Box
import com.artvending.warden.Button
import com.artvending.warden.Card_
import com.artvending.warden.Column
import com.artvending.warden.ContainerScope
import com.artvending.warden.FontWeight
import com.artvending.warden.MdLinearProgress
import com.artvending.warden.MyButton
import com.artvending.warden.Point
import com.artvending.warden.Rectangle
import com.artvending.warden.Row
import com.artvending.warden.Space
import com.artvending.warden.StackScope
import com.artvending.warden.TextAlignment
import com.artvending.warden.Text_
import com.artvending.warden.TimelineUnit
import com.artvending.warden.TimelineUnitMode
import com.artvending.warden.Visibility
import com.artvending.warden.allowDevice
import com.artvending.warden.fixedInterval
import com.artvending.warden.fixingLogger
import com.artvending.warden.humanizeMinutes
import com.artvending.warden.settings
import com.artvending.warden.language
import com.artvending.warden.launch
import com.artvending.warden.minutesToTimeString
import com.artvending.warden.thisMonthHistoryUnits
import com.artvending.warden.toColor
import com.artvending.warden.todayWorkingTime
import com.artvending.warden.userPikalkaId
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.*


@OptIn(ExperimentalComposeWebApi::class)
@Composable
fun StackScope.HomeScreen_(model: HomeScreenModel) {
	@Composable
	fun ContainerScope.CurrentDatetime() {
		Column {
			Text_(model.dateTimeUserData.dateStr, alignment = Alignment.center)
			Text_(model.dateTimeUserData.timeStr, alignment = Alignment.center, classes = settings.displayFontClass, fontWeight = FontWeight.bold)
		}
	}
	
	
	@Composable
	fun ContainerScope.Status() {
		val fixedTime = model.dateTimeUserData.fixedTime
		val fixedTimeFrom = fixedTime?.from
		val fixedTimeTo = fixedTime?.to
		val late = model.dateTimeUserData.late
		
		var color = Color.black
		var text = ""
		
		if (fixedInterval == null || todayWorkingTime == null || late == null) {
			color = Color.red
			text = " "
		}
		else
			if (fixedTimeTo == null) {
				if (fixedTimeFrom == null)
					if (late > 0) {
						color = Color.red
						text = "${language.YOU_ARE_LATE} ${humanizeMinutes(late)}"
					}
					else {
						color = Color.mediumseagreen
						text = language.YOU_ARE_IN_TIME
					}
				else
					if (late > 0) {
						color = Color.darkred
						text = "${language.YOU_LATED} ${minutesToTimeString(fixedTimeFrom)}"
					}
					else {
						color = Color.mediumseagreen
						text = "${language.INCOME_FIXED} ${minutesToTimeString(fixedTimeFrom)}"
					}
			}
			else {
				if (fixedTimeTo < (todayWorkingTime?.to ?: 100000)) {
					color = Color.darkred
					text = "${language.BAD_OUTCOME_FIXED} ${minutesToTimeString(fixedTimeTo)}"
				}
				else {
					color = Color.mediumseagreen
					text = "${language.OUTCOME_FIXED} ${minutesToTimeString(fixedTimeTo)}"
				}
			}
		
		Text_(text, color = color)
	}
	
	
	@Composable
	fun ContainerScope.Timeline() {
		Column(
			classes = settings.labelFontClass,
			textColor = settings.opacityGray,
			visibility = if (fixedInterval == null || todayWorkingTime == null) Visibility.hidden else null
		) {
			val units = model.dateTimeUserData.timelineUnits
			val groups = ArrayList<ArrayList<TimelineUnit>>()
			var currentGroup = ArrayList<TimelineUnit>()
			val lastIndex = units.lastIndex
			
			for ((i, unit) in units.withIndex()) {
				val nextUnit = if (i == lastIndex) null else units[i + 1]
				currentGroup.add(unit)
				
				if (nextUnit == null || nextUnit.mode != unit.mode) {
					groups.add(currentGroup)
					currentGroup = ArrayList<TimelineUnit>()
				}
			}
			
			Row(height = 8.px) {
				for (group in groups) {
					val firstUnitInGroup = group.first()
					
					Rectangle(
						weight = group.size, height = 8.px,
						backgroundColor = when (firstUnitInGroup.mode) {
							TimelineUnitMode.FIXED_TIME -> Color.mediumseagreen
							TimelineUnitMode.LATE -> rgba(255, 0, 0, 0.5)
							TimelineUnitMode.WORKING_TIME -> rgba(0, 0, 0, 0.28)
							else -> settings.opacityLightGray
						}
					)
				}
			}
			Row {
				for (unit in units.filter { it.time % 60 == 0 }) {
					Column(weight = 1) {
						Rectangle(height = 3.px, width = 1.px, backgroundColor = settings.opacityLightGray)
						Text_((unit.time / 60).toString(), paddingTop = 2.px, alignment = Alignment.start, style = { property("transform", "translate(-50%, 0%)") })
					}
				}
				
				val lastUnit = model.dateTimeUserData.timelineUnits.lastOrNull()
				
				if (lastUnit != null) {
					Column(width = 1.px) {
						Rectangle(height = 3.px, width = 1.px, backgroundColor = settings.opacityLightGray)
						Text_(((lastUnit.time / 60) + 1).toString(), paddingTop = 2.px, alignment = Alignment.start, style = { property("transform", "translate(-50%, 0%)") })
					}
				}
			}
		}
	}
	
	
	@Composable
	fun ContainerScope.WorkingTime() {
		Column(visibility = if (fixedInterval == null || todayWorkingTime?.from == null) Visibility.hidden else null) {
			Text_(language.YOUR_WORKING_CALENDAR, color = settings.opacityGray, classes = settings.labelFontClass)
			Text_("${minutesToTimeString(todayWorkingTime?.from)} - ${minutesToTimeString(todayWorkingTime?.to)}")
		}
	}

//	@Composable
//	fun ContainerScope.ProgressBar() {
//		println("fixedInterval = $fixedInterval")
//		println("todayWorkingTime = $todayWorkingTime")
//
//		if (fixedInterval == null || todayWorkingTime == null) {
//			println(222)
//
//			if (userPikalkaId == "") {
//				println(333)
//				Text_(language.USER_DIDNT_SET, vAlignment = Alignment.center)
//			}
//			else
//				MdLinearProgress(null, { style { margin(0.px, settings.space); gridArea("1 / 1"); alignSelf("center") } })
//		}
//	}
	
	@Composable
	fun ContainerScope.ProgressBar() {
		if (thisMonthHistoryUnits == null && userPikalkaId != "")
			MdLinearProgress(null) { style { margin(0.px, settings.space); gridArea("1 / 1"); alignSelf("center") } }
		
		if (userPikalkaId == "")
			Text_(language.USER_DIDNT_SET, alignment = Alignment.center, textAlignment = TextAlignment.center)
	}
	
	Column {
		Space(weight = 1)
//		Button("TEST") {
//			launch {
//				fixingLogger.fix(Point(0.0, 12.0), "test")
//			}
//		}
		Card_ {
			CurrentDatetime()
			Box {
				Column(space = settings.space) {
					Timeline()
					WorkingTime()
					Status()
				}
				ProgressBar()
			}
			MyButton(
				{
					if (allowDevice == true)
						model.go()
				},
				{
					style {
						alignSelf(AlignSelf.Stretch)
						
						if (allowDevice != true)
							property("opacity", "0")
						
						property("--md-filled-button-label-text-color", "white")
						property("--md-filled-button-container-color", model.getButtonColor().toColor())
					}
				}
			) {
				org.jetbrains.compose.web.dom.Text(if (fixedInterval?.from == null) language.INCOME else if (fixedInterval?.to == null) language.OUTCOME else language.RE_OUTCOME)
			}
		}
		Space(weight = 1.5)
	}
}